import React, { Component, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import history from "@history";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  IconButton,
  Typography,
  Grid,
  Link as MuiLink,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import SchoolIcon from "@mui/icons-material/School";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

class SignUp extends Component {
  state = {
    lang: "en-US",
  };

  onSelectRole = (role: "host" | "youth") => {
    if (role === "youth") {
      history.push(`/sign-up/${role}/login-info`);
    } else {
      history.push(`/sign-up/${role}/${role}-info`);
    }
  };

  handleLanguageChange = (event: any) => {
    this.setState({ lang: event.target.value });
  };

  render(): ReactNode {
    const { lang } = this.state;

    return (
      <Box
        minHeight="100vh"
        bgcolor="#f5f5f5"
        display="flex"
        alignItems="center"
        justifyContent="center"
        p={2}
      >
        <Box
          width="100%"
          maxWidth={600}
          bgcolor="white"
          borderRadius={2}
          boxShadow={2}
          p={4}
        >
          {/* --- Logo + Title --- */}
          <Box mb={3}>
            <Box display="flex" alignItems="center" mb={1}>
              <img
                src="assets/images/logo/logo-ypms-full.png"
                alt="YPMS Logo"
                style={{ height: 40 }}
              />
            </Box>
            <Typography variant="h5" fontWeight={600}>
              Sign up
            </Typography>
          </Box>

          {/* --- Two Cards Side-by-Side --- */}
          <Grid container spacing={2}>
            {[
              {
                key: "youth",
                label: "I am Youth",
                Icon: SchoolIcon,
                circleBg: "#e0f2f1",
                iconColor: "#00796b",
              },
              {
                key: "host",
                label: "I am Host",
                Icon: BusinessIcon,
                circleBg: "#e3f2fd",
                iconColor: "#1565c0",
              },
            ].map(({ key, label, Icon, circleBg, iconColor }) => (
              <Grid item xs={6} key={key}>
                <Card variant="outlined" sx={{ borderRadius: 2 }}>
                  <CardActionArea
                    onClick={() => this.onSelectRole(key as any)}
                    sx={{ p: 3, height: "100%" }}
                  >
                    <Box display="flex" justifyContent="center" mb={1}>
                      <Box
                        bgcolor={circleBg}
                        borderRadius="50%"
                        p={2}
                        display="inline-flex"
                      >
                        <Icon sx={{ fontSize: 40, color: iconColor }} />
                      </Box>
                    </Box>
                    <Typography align="center" fontWeight={500}>
                      {label}
                    </Typography>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* --- Sign-in Link --- */}
          <Box mt={3} mb={1}>
            <Typography variant="body2">
              Already have an account?{" "}
              <MuiLink component={RouterLink} to="/sign-in">
                Sign in
              </MuiLink>
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* --- Footer: Language Select + Links --- */}
          <Box
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <FormControl size="small">
              <InputLabel id="lang-label">English - US</InputLabel>
              <Select
                labelId="lang-label"
                value={lang}
                label="Language"
                onChange={this.handleLanguageChange}
              >
                <MenuItem value="en-US">English – US</MenuItem>
                {/* add more here if you like */}
              </Select>
            </FormControl>
            <Box>
              {["Help", "Privacy", "Terms"].map((txt) => (
                <MuiLink
                  href="#"
                  key={txt}
                  sx={{ mx: 1, fontSize: "0.875rem" }}
                >
                  {txt}
                </MuiLink>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default SignUp;
